
import { Options, prop, Vue } from "vue-class-component";
import { debounce } from "lodash";
import { ellipsisString } from "@/app/infrastructures/misc/Utils";
import {
  CommodityBookingV4,
  CommodityCategoryV4
} from "@/domain/entities/BookingV4";
import { createFocusTrap } from "focus-trap";

class Props {
  recommendedCommodities = prop<CommodityBookingV4[]>({
    required: true,
    default: () => []
  });
  searchResults = prop<CommodityBookingV4[]>({
    required: true,
    default: () => []
  });
  categories = prop<CommodityCategoryV4[]>({
    required: true,
    default: () => []
  });
  categoryCommodities = prop<CommodityBookingV4[]>({ default: () => [] });
  selectedCategoryCode = prop<string | null>({ default: null });
  isForeign = prop<boolean>({ required: true, default: false, type: Boolean });
  loading = prop<boolean>({ default: false, type: Boolean });
  loadingCategory = prop<boolean>({ default: false, type: Boolean });
  hasMore = prop<boolean>({ default: false, type: Boolean });
}

@Options({
  name: "ModalAllCommodityV4",
  emits: ["close", "search", "loadMore", "selectCategory", "select"]
})
class ModalAllCommodityV4 extends Vue.with(Props) {
  search = "";
  isFocused = false;
  selectedSearchItem = "";
  selectedCategoryItem = "";
  categorySelected = "";

  onClose() {
    if (this.focusTrap) {
      this.focusTrap.deactivate();
      this.focusTrap = null;
    }

    this.$emit("close");
  }

  displayName(item: CommodityBookingV4): string {
    if (this.isForeign && item.nameEn) return item.nameEn.toLowerCase();
    return item.name.toLowerCase();
  }

  displayCategory(categories: CommodityCategoryV4): string {
    if (this.isForeign && categories.nameEn)
      return categories.nameEn.toLowerCase();
    return categories.name.toLowerCase();
  }

  ellipsisText(val: string, length: number) {
    return ellipsisString(val, length);
  }

  emitSearch = debounce((keyword: string) => {
    this.$emit("search", keyword);
  }, 500);

  onInputSearch(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.search = value;
    this.selectedSearchItem = ""; // Clear selection when searching

    this.emitSearch(value);
  }

  clearSearch() {
    this.search = "";
    this.isFocused = false;
    this.$emit("search", "");
  }

  onSelectCategory(code: string) {
    this.categorySelected = code;
    this.selectedCategoryItem = "";

    this.$emit("selectCategory", code);
  }

  onSelect(item: CommodityBookingV4) {
    this.$emit("select", item);
    this.clearSearch();
  }

  // focus trap
  focusTrap: any = null;
  onModalRef(event: any) {
    if (this.focusTrap || !event?.$el) return;
    this.initFocusTrap(event.$el);
  }

  async initFocusTrap(el: any) {
    await this.$nextTick();
    this.focusTrap = createFocusTrap(el, {
      escapeDeactivates: true,
      allowOutsideClick: true,
      returnFocusOnDeactivate: true,
      clickOutsideDeactivates: false,
      onDeactivate: this.onClose
    });

    this.focusTrap.activate();
  }

  isCategorySelected(val: string) {
    return val === this.categorySelected;
  }
}

export default ModalAllCommodityV4;
